import { useId } from "react";

import { FormField } from "~/components/ui/form-field";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "~/components/ui/select";

import { useFieldContext } from "./field-context";
import { useFieldError } from "./field-errors";

export function SelectField({
  label,
  placeholder,
  required,
  helpText,
  options,
}: {
  label?: string;
  placeholder?: string;
  required?: boolean;
  helpText?: string;
  options: { value: string; label: string }[];
}) {
  const field = useFieldContext<string>();
  const error = useFieldError(field.name);
  const id = useId();
  return (
    <FormField
      inputId={id}
      label={label}
      required={required}
      helpText={helpText}
      error={error}
    >
      <Select
        value={field.state.value ?? ""}
        onValueChange={field.handleChange}
      >
        <SelectTrigger id={id} className="w-full">
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((o) => (
            <SelectItem key={o.value} value={o.value}>
              {o.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </FormField>
  );
}
